.flip-button,.flip-button-accent,.flip-button-primary{border-radius:5px!important;height:62px!important;letter-spacing:0px;width:257px!important;margin-top:3px;margin-right:3px}
/*# sourceMappingURL=flip-button.component-CLVINX5J.css.map */
